module.exports = __webpack_public_path__ + "img/tab.e1e7f1a5.svg";